import { ViewContainerRef } from '@angular/core';

export const HeaderComponent_AfterViewInit = 'HeaderComponent_AfterViewInit';

/**
 * Компонент HeaderComponent, хук AfterViewInit
 */
export interface IHeaderComponent_AfterViewInit {
    vcrHeaderRight: ViewContainerRef;
}
